var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 54,
    viewBox: "0 0 98 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "ladekabel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16547 31.9737V54H0V27.7105C0 22.0263 4.93525 15.6316 12.6906 15.6316H37.2706C39.5984 5.21053 48.0476 0 52.8777 0H79.6691V7.81579H98V13.5H79.6691V27H98V33.3947H79.6691V41.9211H52.8777C48.0539 41.9211 39.6202 37.2437 37.2796 27H36.6619H12.6906C9.8705 27 9.16547 30.3158 9.16547 31.9737Z",
    fill: "#0375D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.7ad7d229.svg";
export { ForwardRef as ReactComponent };